const REQUEST_STATS_CONFIG = '@@config/REQUEST_STATS_CONFIG';
const STATS_CONFIG_RESPONSE = '@@config/STATS_CONFIG_RESPONSE';

export default {
    REQUEST_STATS_CONFIG,
    STATS_CONFIG_RESPONSE,
};
